module.exports = __webpack_public_path__ + "static/img/tableBanner.ca58c069.png";